import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Crown, Award } from "lucide-react";
import { api } from "@/lib/api";

/**
 * <BuildOfTheMonth /> — current month's top-voted public garage vehicle.
 * Renders nothing while the community is still bootstrapping (0 votes).
 */
export default function BuildOfTheMonth() {
    const [data, setData] = useState(null);

    useEffect(() => {
        api.get("/build-of-the-month")
            .then((r) => setData(r.data))
            .catch(() => setData(null));
    }, []);

    if (!data?.winner) return null;
    const w = data.winner;

    return (
        <section className="max-w-6xl mx-auto px-5 py-8" data-testid="build-of-the-month">
            <div className="flex items-center gap-2 mb-4">
                <Crown className="w-5 h-5 text-hellcat" />
                <div className="label-caps text-hellcat">Build of the Month</div>
            </div>
            <Link
                to={`/users/${w.owner_id}`}
                data-testid="botm-card"
                className="block rounded-3xl overflow-hidden relative group"
                style={{
                    background: "linear-gradient(160deg, rgba(20,10,10,0.85), rgba(10,5,5,0.9))",
                    border: "1px solid rgba(225,6,0,0.35)",
                    minHeight: 320,
                }}
            >
                {w.photos?.[0] ? (
                    <img
                        src={w.photos[0]}
                        alt={`${w.year} ${w.model_name} ${w.trim}`}
                        className="absolute inset-0 w-full h-full object-cover opacity-70 group-hover:opacity-90 transition-opacity"
                    />
                ) : null}
                <div className="absolute inset-0" style={{
                    background: "linear-gradient(180deg, transparent 30%, rgba(0,0,0,0.9) 100%)",
                }} />
                <div className="relative z-10 h-full flex flex-col justify-end p-6 sm:p-8" style={{ minHeight: 320 }}>
                    <div className="flex items-center gap-2 mb-2">
                        <span className="chip" style={{
                            background: "rgba(225,6,0,0.2)",
                            borderColor: "rgba(225,6,0,0.5)",
                            color: "#FF6E68",
                        }}>
                            <Award className="w-3 h-3" /> {w.votes} votes
                        </span>
                    </div>
                    <h2 className="text-3xl sm:text-4xl text-white leading-tight"
                        style={{ fontFamily: "'Alfa Slab One', serif", fontStyle: "italic" }}>
                        {w.year} {w.model_name} {w.trim}
                    </h2>
                    <div className="text-sm text-white/85 mt-2">
                        Built by <span className="text-hellcat font-bold">{w.owner?.name}</span>
                    </div>
                </div>
            </Link>
        </section>
    );
}
